import * as React from 'react'

import { type IParseFile, nuvoSession } from 'nuvo-react'

interface UseFileUploadProps {
  onFileUpload?: (file: File) => void
}

export const useFileUpload = ({ onFileUpload }: UseFileUploadProps = {}) => {
  const [parsedFile, setParsedFile] = React.useState<IParseFile[] | undefined>(undefined)
  const [parseFileLoading, setParseFileLoading] = React.useState<boolean>(false)

  const handleFileUpload = async (uploadedFile: File[] | undefined) => {
    if (!uploadedFile || !uploadedFile[0]) return

    setParseFileLoading(true)
    const nuvoParsed = await nuvoSession.parse(uploadedFile)
    setParsedFile(nuvoParsed.accepted)
    setParseFileLoading(false)

    onFileUpload?.(uploadedFile[0])
  }

  return {
    parsedFile,
    parseFileLoading,
    handleFileUpload,
  }
}
